import {createHooks} from "@wordpress/hooks";

/**
 * Global variable for booking. This uses to expose public methods.
 *
 * @use window.wc_bookings.hooks
 *
 * @since 1.15.79
 */
export const HookApi = () => {
	return window.wc_bookings.hooks;
};

export const BookingDisabledClass = 'disabled';

/**
 * Set the button disabled state.
 *
 * @param {JQuery<HTMLElement>} button
 * @param {boolean}             disabled
 * @returns {void}
 */
export const SetButtonDisabled = ( button, disabled ) => {
	if ( disabled ) {
		button.addClass( BookingDisabledClass ).attr( 'aria-disabled', 'true' ).attr('disabled', 'disabled');
	} else {
		button.removeClass( BookingDisabledClass ).removeAttr( 'aria-disabled' ).removeAttr('disabled');
	}
};
